import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  rowKey: 'index',
  column: [
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      slot: true,
      search: true,
      searchOrder: 998,
      width: 100,
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      type: 'input',
    },
    {
      label: '是否省代',
      prop: 'provincialRepresentative',
      type: 'select',
      search: true,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      searchOrder: 994,
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      // type: 'cascader',
      dicData: store.getters.porductTypes,
      // dicData: store.getters.porductCascader,
      searchCheckStrictly:true,
      searchMultiple: true,
      hide: true,
      search: true,
      searchOrder: 999,
      // searchCollapseTags:true,
      cascader: ['lendingRate'],
    },
    {
      label: '租率',
      prop: 'lendingRate',
      type: 'select',
      width: 70,
      formatter: (val, value, label) => {
        return value ? value + '%' : '-';
      },
    },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'input',
      width: 50,
      formatter: (val, value, label) => {
        return value ? value + '期' : '-';
      },
    },
    {
      label: '申请金额',
      prop: 'needAmount',
      type: 'input',
      width: 100,
    },
    {
      label: '收购价',
      prop: 'groupAssessAmount',
      type: 'input',
      width: 100,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'number',
      controls: false,
      search: false,
    },
    {
      label: '放款方式',
      prop: 'lendingType',
      type: 'input',
      slot: true,
    },
    {
      label: '是否重复',
      prop: 'isRepeat',
      type: 'select',
      width: 180,
      search: true,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 2,
        },
      ],
      searchOrder: 995,
      formatter: (val, value, label) => {
        return value === 1 || value === 3 ? '重复' : '-';
      },
    },
    {
      label: '是否特批',
      prop: 'isSpecial',
      type: 'select',
      search: true,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 2,
        },
      ],
      searchOrder: 993,
    },
    {
      label: '审核节点',
      prop: 'auditNode',
      slot: true,
      width: 180,
    },
    {
      label: '更新时间',
      prop: 'updateTime',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: false,
      width: 90,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      slot: true,
      // search: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      width: 120,
      searchOrder: 998,
      hide: true,
    },
    // {
    //   label: '手机号',
    //   prop: 'phoneNumber',
    //   type: 'input',
    //   search: true,
    //   width: 100,
    // },
    // {
    //   label: '每期租金',
    //   prop: 'lendingAmountPer',
    //   type: 'input',
    //   width: 80,
    // },
    {
      label: '起租日',
      prop: 'commencementDate',
      type: 'input',
      width: 90,
      hide: true,
    },
    // {
    //   label: '型号',
    //   prop: 'carModel',
    //   type: 'input',
    //   hide: true,
    // },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      width: 100,
      hide: true,
      search: true,
      slot: true,
      searchOrder: 997,
    },
    {
      label: '节点名称',
      prop: 'taskDefinitionKeyList',
      type: 'select',
      search: true,
      searchMultiple: true,
      searchClearable: true,
      hide: true,
      addDisplay: false,
      editDisplayf: false,
      viewDisplay: false,
      width: 150,
      dicData: [],
      searchOrder: 992,
    },
    {
      label: '负责人',
      prop: 'groupPingguTransfer',
      type: 'select',
      search: true,
      hide: true,
      dicData: [
        {
          label: '评估师',
          value: 1,
        },
        {
          label: '主管',
          value: 2,
        },
        {
          label: '负责人',
          value: 3,
        },
      ],
    },
    {
      label: '负责人',
      prop: 'groupFengkongTransfer',
      type: 'select',
      search: true,
      hide: true,
      dicData: [
        {
          label: '风控专员',
          value: 1,
        },
        {
          label: '主管',
          value: 2,
        },
        {
          label: '负责人',
          value: 3,
        },
      ],
    },
    {
      label: '创建人',
      prop: 'createUser',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
      width: 90,
    },
    {
      label: '新增日期',
      prop: 'commitTimeRange',
      type: 'daterange',
      search: true,
      searchRange: true,
      dataType: 'string',
      hide: true,
      valueFormat: 'yyyy-MM-dd',
      searchOrder: 996,
    },
    // {
    //   label: '起租日',
    //   prop: 'commencementDateRange',
    //   type: 'daterange',
    //   search: true,
    //   searchRange: true,
    //   dataType: 'string',
    //   hide: true,
    //   valueFormat: 'yyyy-MM-dd',
    //   searchOrder: 996,
    // },
    {
      label: '所属代理商',
      prop: 'createDept',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '修改人',
      prop: 'updateUser',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '状态',
      prop: 'status',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '是否已删除',
      prop: 'isDeleted',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '进件编号',
      value: 'businessCode',
      order: 1,
    },
    {
      title: '姓名',
      value: 'name',
      order: 2,
    },
    {
      title: '所属代理商',
      value: 'deptName',
      order: 3,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 4,
    },
    // {
    //   title: '品牌',
    //   value: 'lendingRate',
    //   order: 5,
    // },
    {
      title: '车牌号',
      value: 'carFirstNumber',
      order: 6,
    },
    {
      title: '起租日',
      value: 'commencementDate',
      order: 7,
    },
    {
      title: '审核节点',
      value: 'auditNode',
      order: 8,
    },
    {
      title: '更新时间',
      value: 'updateTime',
      order: 9,
    },
  ],
};
